import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { isActiveMenuPath, getBrowserPathname } from "../../utils/appPaths";
import { getMenuItemsForRole, normalizeUserRole } from "./Menu";

const isMenuItemActive = (currentPath, menuItem) => {
  if (menuItem.path && isActiveMenuPath(currentPath, menuItem.path)) {
    return true;
  }
  if (!menuItem.children) return false;
  return menuItem.children.some(
    (child) =>
      (child.path && isActiveMenuPath(currentPath, child.path)) ||
      (child.children &&
        child.children.some(
          (sub) => sub.path && isActiveMenuPath(currentPath, sub.path)
        ))
  );
};

const SidebarMenuItems = ({
  MENUITEMS: menuSections,
  setMainMenu,
  sidebartoogle,
  setNavActive,
  activeClass,
  userRole,
}) => {
  const role = normalizeUserRole(userRole);
  const sections = menuSections || getMenuItemsForRole(role);
  const { layout } = useContext(CustomizerContext);
  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const CurrentPath = getBrowserPathname();
  const id = CurrentPath.split("/").pop();
  const layoutId = id;

  const { t } = useTranslation();
  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      const pageHeader = document.querySelector(".page-header");
      const sidebarWrapper = document.querySelector(".sidebar-wrapper");
      if (pageHeader) pageHeader.className = "page-header close_icon";
      if (sidebarWrapper) sidebarWrapper.className = "sidebar-wrapper close_icon ";
      if (item.type === "sub") {
        if (pageHeader) pageHeader.className = "page-header";
        if (sidebarWrapper) sidebarWrapper.className = "sidebar-wrapper";
      }
    }
    if (!item.active) {
      getMenuItemsForRole(role).forEach((a) => {
        a.Items.filter((Items) => {
          if (a.Items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu(getMenuItemsForRole(role));
  };

  return (
    <>
      {sections.map((Item, i) => (
        <Fragment key={i}>
          {/* THIS IS THE SIDEBAR GROUP TITLE */}
          {/* <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(Item.menutitle)}</h6>
            </div>
          </li> */}

          {Item.Items.map((menuItem, i) => (
            <li className="sidebar-list" key={i}>
              {menuItem.type === "sub" ? (
                <a
                  href="javascript"
                  className={`sidebar-link sidebar-title ${
                    isMenuItemActive(CurrentPath, menuItem) ? "active" : ""
                  } ${menuItem.active && "active"}`}
                  onClick={(event) => {
                    event.preventDefault();
                    setNavActive(menuItem);
                    activeClass(menuItem.active);
                  }}
                >
                  <SvgIcon
                    className="stroke-icon"
                    iconId={`stroke-${menuItem.icon}`}
                  />
                  <SvgIcon
                    className="fill-icon"
                    iconId={`fill-${menuItem.icon}`}
                  />
                  <span>{t(menuItem.title)}</span>
                  {menuItem.badge ? (
                    <label className={menuItem.badge}>
                      {menuItem.badgetxt}
                    </label>
                  ) : (
                    ""
                  )}
                  <div className="according-menu">
                    {menuItem.active ? (
                      <i className="fa fa-angle-down"></i>
                    ) : (
                      <i className="fa fa-angle-right"></i>
                    )}
                  </div>
                </a>
              ) : (
                ""
              )}

              {menuItem.type === "link" ? (
                <Link
                  to={menuItem.path}
                  className={`sidebar-link sidebar-title link-nav  ${
                    isMenuItemActive(CurrentPath, menuItem) ? "active" : ""
                  }`}
                  onClick={() => toggletNavActive(menuItem)}
                >
                  <SvgIcon
                    className="stroke-icon"
                    iconId={`stroke-${menuItem.icon}`}
                  />
                  <SvgIcon
                    className="fill-icon"
                    iconId={`fill-${menuItem.icon}`}
                  />
                  <span>{t(menuItem.title)}</span>
                  {menuItem.badge ? (
                    <label className={menuItem.badge}>
                      {menuItem.badgetxt}
                    </label>
                  ) : (
                    ""
                  )}
                </Link>
              ) : (
                ""
              )}

              {menuItem.children ? (
                <ul
                  className="sidebar-submenu"
                  style={
                    layout1 !== "compact-sidebar compact-small"
                      ? menuItem?.active || isMenuItemActive(CurrentPath, menuItem)
                        ? sidebartoogle
                          ? { opacity: 1, transition: "opacity 500ms ease-in" }
                          : { display: "block" }
                        : { display: "none" }
                      : { display: "none" }
                  }
                >
                  {menuItem.children.map((childrenItem, index) => {
                    return (
                      <li key={index}>
                        {childrenItem.type === "sub" ? (
                          <a
                            href="javascript"
                            //className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`}
                            className={`${childrenItem.active ? "active" : ""}`}
                            onClick={(event) => {
                              event.preventDefault();
                              toggletNavActive(childrenItem);
                            }}
                          >
                            {t(childrenItem.title)}
                            <span className="sub-arrow">
                              <i className="fa fa-chevron-right"></i>
                            </span>
                            <div className="according-menu">
                              {childrenItem.active ? (
                                <i className="fa fa-angle-down"></i>
                              ) : (
                                <i className="fa fa-angle-right"></i>
                              )}
                            </div>
                          </a>
                        ) : (
                          ""
                        )}

                        {childrenItem.type === "link" ? (
                          // <Link
                          //   to={childrenItem.path + "/" + layoutId}
                          //   /* className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`} */
                          //   /* className={`${childrenItem.active ? 'active' : ''}`} */
                          //   onClick={() => toggletNavActive(childrenItem)}>
                          //   {t(childrenItem.title)}
                          // </Link>
                          <Link
                            to={childrenItem.path}
                            onClick={() => toggletNavActive(childrenItem)}
                          >
                            {t(childrenItem.title)}
                          </Link>
                        ) : (
                          ""
                        )}

                        {childrenItem.children ? (
                          <ul
                            className="nav-sub-childmenu submenu-content"
                            style={
                              (childrenItem.path &&
                                isActiveMenuPath(CurrentPath, childrenItem.path)) ||
                              childrenItem.active
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            {childrenItem.children.map(
                              (childrenSubItem, key) => (
                                <li key={key}>
                                  {childrenSubItem.type === "link" ? (
                                    // <Link
                                    //   to={childrenSubItem.path + "/" + layoutId}
                                    //   className={`${CurrentPath.includes(childrenSubItem?.title?.toLowerCase()) ? "active" : ""}`}
                                    //   // className={`${childrenSubItem.active ? 'active' : ''}`}
                                    //   onClick={() => toggletNavActive(childrenSubItem)}>
                                    //   {t(childrenSubItem.title)}
                                    // </Link>
                                    <Link
                                      to={childrenSubItem.path}
                                      className={`${
                                        childrenSubItem.path &&
                                        isActiveMenuPath(
                                          CurrentPath,
                                          childrenSubItem.path
                                        )
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        toggletNavActive(childrenSubItem)
                                      }
                                    >
                                      {t(childrenSubItem.title)}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                ""
              )}
            </li>
          ))}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
